import FormElement from "./form-element";
import Input, { FormParams } from "./input";

export default function EmailInput(params: FormParams) {
  return (
    <FormElement
      id={params.id}
      label={params.label}
      className={params.className}
    >
      <Input type="email" autoComplete="email" {...params} />
    </FormElement>
  );
}
